// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_7rb","alignRight":"e_8rb","alignLeft":"e_9rb","item":"e_-rb","icon":"e_asb","soft":"e_bsb"};